export enum DoorSeries {
  DP = 'DP',
  DL = 'DL',
  DE = 'DE',
  DF = 'DF',
}
